export default {
  redButton: {
    color: "white",
    background: "#ff0000",
    "&:hover": {
      background: "#910000"
    }
  }
};
